"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _defaultState = require("../view/defaultState");
var _defaultState2 = require("../tabs/defaultState");
var _defaultState3 = require("../flow/defaultState");
var _defaultState4 = require("../login/defaultState");
var _defaultState5 = require("../authentication/defaultState");
var _defaultState6 = require("../registration/defaultState");
var _defaultState7 = require("../social/defaultState");
var _defaultState8 = require("../phoneAuth/defaultState");
var _defaultState9 = require("../agreement/defaultState");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const defaultState = exports.defaultState = {
  view: _defaultState.defaultState,
  activeTab: _defaultState2.defaultState,
  activeFlow: _defaultState3.defaultState,
  login: _defaultState4.defaultState,
  phoneAuth: _objectSpread({}, _defaultState8.defaultState),
  authentication: _objectSpread({}, _defaultState5.defaultState),
  registration: _objectSpread({}, _defaultState6.defaultState),
  social: _objectSpread({}, _defaultState7.defaultState),
  agreement: _objectSpread({}, _defaultState9.defaultState),
  autoFocusDisabled: false,
  isRememberAccountsFlow: false,
  source: null,
  subdomain: 'www'
};